<script>
    const nome = localStorage.getItem("nome");
    const email = localStorage.getItem("email");
    const selectedDateStr = localStorage.getItem("selectedDate");
    const selectedDate = selectedDateStr ? new Date(selectedDateStr.replace(/"/g, "")) : null;
    const selectedHour = localStorage.getItem("selectedHour").replace(/"/g, "");
    const selectedServices = JSON.parse(localStorage.getItem("selectedServices"));
    const telefono = localStorage.getItem("telefono");
</script>

<style>
    .cb-div{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-top: 10%;
        text-align: center;
    }
    .cb-div img{
        width: 100px;
        height: 100px;
    }
    .label{
        font-weight: bold;
    }
    .cb-label-div{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    @media screen and (max-width: 768px){
        .cb-div{
            margin-top: 5%;
        }
    }
</style>

<div class="cb-div">
    <div style="margin-bottom: 50px; display: flex; flex-direction: column; align-items: center;">
        <img src="./icons/check.png" alt="congrats">
        <span style="font-size:26px;">Il tuo appuntamento è confermato!</span>
    </div>
    <div style="font-size:18px; width: 100%;">
        <div class="cb-label-div">
            <span class="label">Nome:</span>
            <span class="value">{nome}</span>
        </div>
        <div class="cb-label-div">
            <span class="label">Email:</span>
            <span class="value">{email}</span>
        </div>
        <div class="cb-label-div">
            <span class="label">Numero di telefono:</span>
            <span class="value">{telefono}</span>
        </div>
        <div class="cb-label-div">
            <span class="label">Data selezionata:</span>
            <span class="value">{selectedDate ? selectedDate.toLocaleDateString() : ''}</span>
        </div>
        <div class="cb-label-div">
            <span class="label">Ora selezionata:</span>
            <span class="value">{selectedHour}</span>
        </div>
        <div class="cb-label-div">
            <span class="label">Servizi selezionati:</span>
            <span class="value" style="max-width: 30%;">{selectedServices.join(", ")}</span>
        </div>
    </div>
</div>